// src/store/features/undoRedoSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface GameState {
  gameCode: string
  gameConfig: any
  gameDetails: {
    gameId: string
    coverImage: string
    gameStatus: string
    gameVisibility: 'public' | 'unlisted'
  }
}

interface UndoRedoState {
  past: GameState[]
  present: GameState | null
  future: GameState[]
}

const initialState: UndoRedoState = {
  past: [],
  present: null,
  future: []
}

const MAX_HISTORY_LENGTH = 20

const undoRedoSlice = createSlice({
  name: 'undoRedo',
  initialState,
  reducers: {
    saveState: (state, action: PayloadAction<GameState>) => {
      if (state.present && JSON.stringify(state.present) !== JSON.stringify(action.payload)) {
        state.past.push(state.present)
        if (state.past.length > MAX_HISTORY_LENGTH) {
          state.past.shift()
        }
        state.present = action.payload
        state.future = []
      } else if (!state.present) {
        state.present = action.payload
      }
    },
    undo: (state) => {
      if (state.past.length > 0) {
        const previous = state.past.pop()!
        if (state.present) {
          state.future.unshift(state.present)
        }
        state.present = previous
      }
    },
    redo: (state) => {
      if (state.future.length > 0) {
        const next = state.future.shift()!
        if (state.present) {
          state.past.push(state.present)
        }
        state.present = next
      }
    }
  }
})

export const { saveState, undo, redo } = undoRedoSlice.actions

export const selectUndoRedoState = (state: RootState) => state.undoRedo
export const selectCanUndo = (state: RootState) => state.undoRedo.past.length > 0
export const selectCanRedo = (state: RootState) => state.undoRedo.future.length > 0

export default undoRedoSlice.reducer